import { Link, NavLink } from "react-router-dom";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/team", label: "The Team" },
  { to: "/services", label: "Services" },
  { to: "/gallery", label: "Gallery" },
  { to: "/shop", label: "Shop" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  return (
    <header data-testid="site-navbar" className="sticky top-0 z-50 bg-[#0a0a0a] border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 min-h-16 py-2 flex items-center justify-between gap-3 flex-wrap">
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-3 group shrink-0">
          <img
            src="/logo.png"
            alt="JCD Customs & Marine logo"
            className="h-9 sm:h-11 w-auto transition-transform duration-200 group-hover:-translate-y-0.5"
          />
        </Link>

        <nav className="flex flex-wrap items-center justify-end gap-x-3 sm:gap-x-6 gap-y-2" data-testid="navbar-links">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `label-industrial text-xs sm:text-sm transition-colors duration-150 hover:text-ember ${
                  isActive ? "text-ember" : "text-gray-300"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-book-btn"
            className="label-industrial text-xs sm:text-sm bg-ember text-white px-3 sm:px-5 py-2 sm:py-2.5 hover:bg-ember-hover transition-colors duration-150"
          >
            Book a Job
          </Link>
        </nav>
      </div>
    </header>
  );
};
